/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */

/**
 * 0 = Task

1 = Punch list

2 = Schedule item


 */
export type TaskTypes = (typeof TaskTypes)[keyof typeof TaskTypes];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TaskTypes = {
  Task: 0,
  PunchList: 1,
  ScheduleItem: 2,
} as const;
